module.exports = __webpack_public_path__ + "media/make7.65f932e1.mp4";